import Cookies from 'js-cookie';

const redirectKey = 'REDIRECT_PATHNAME'

const inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000);

export const RedirectOptions = {
    get: () => Cookies.get(redirectKey),
    set: (value, options) => Cookies.set(redirectKey, value, Object.assign({ expires: inFiveMinutes }, options)),
    remove: () => Cookies.remove(redirectKey)
}

export default Cookies